// useModuleQuiz.js
import { useQuery } from '@tanstack/react-query';
import { getModuleQuiz } from '../services/moduleService';

export function useModuleQuiz(moduleId) {
    return useQuery({
      queryKey: ['moduleQuiz', moduleId],
      queryFn: () => getModuleQuiz(moduleId),
      staleTime: 5 * 60 * 1000,
      cacheTime: 30 * 60 * 1000,
      enabled: !!moduleId,
    });
  }